module.exports = __webpack_public_path__ + "static/media/edit-lecture.34c4fb74.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/edit-lecture.png
// module id = 337
// module chunks = 6